import React from 'react';
import styled, { css } from 'styled-components';
import { brandColours, minBreakpointQuery, sectionMargins } from '../styles';
import { Container, Heading, HtmlContent } from './ui';
import { slugify } from '../utils';

const StyledContent = styled.section`
  ${({
    contain,
    isBlogDetail,
    isCaseStudyDetail,
    isSalesforceExplainerDetail,
  }) => {
    if (
      !contain &&
      !isBlogDetail &&
      !isCaseStudyDetail &&
      !isSalesforceExplainerDetail
    ) {
      return css`
        ${sectionMargins()};
      `;
    } else {
      return css`
        ${sectionMargins('20px', '40px')};
      `;
    }
  }}
`;

const StyledContainer = styled(Container)`
  ${({ isBlogDetail }) => {
    if (isBlogDetail) {
      return css`
        padding-left: 0;
        padding-right: 0;
      `;
    }
  }};
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 20px;
`;

const StyledInner = styled.div`
  ${({ centerAlignText }) => {
    if (centerAlignText) {
      return css`
        text-align: center;
      `;
    }
  }};

  ${({ twoColumns }) => {
    if (twoColumns) {
      return css`
        ${minBreakpointQuery.mlarge`
          column-count: 2;
          column-gap: 60px;
        `}

        ${minBreakpointQuery.large`
          column-gap: 80px;
        `}

        ${minBreakpointQuery.xxlarge`
          column-gap: 100px;
        `}
      `;
    }
  }};

  ${({ highlight }) => {
    if (highlight) {
      return css`
        padding: 30px;
        background-color: ${brandColours.primary};

        ${minBreakpointQuery.small`
          padding: 40px;
        `}

        ${minBreakpointQuery.medium`
          padding: 60px;
        `}

        ${minBreakpointQuery.large`
          padding: 80px;
        `}

        ${minBreakpointQuery.xxlarge`
          padding: 100px;
        `}
      `;
    }
  }};
`;

const Content = ({
  heading,
  content,
  centerAlignText,
  twoColumns,
  highlight,
  contain,
  isBlogDetail,
  isCaseStudyDetail,
  isSalesforceExplainerDetail,
}) => (
  <StyledContent
    contain={contain}
    isBlogDetail={isBlogDetail}
    isCaseStudyDetail={isCaseStudyDetail}
    isSalesforceExplainerDetail={isSalesforceExplainerDetail}
  >
    <StyledContainer
      narrower={isBlogDetail || isSalesforceExplainerDetail}
      narrow={(contain && !highlight) || isCaseStudyDetail}
      isBlogDetail={isBlogDetail}
    >
      <StyledInner
        centerAlignText={centerAlignText}
        twoColumns={twoColumns}
        highlight={highlight}
      >
        {heading && (
          <StyledHeading
            {...(isBlogDetail && {
              id: slugify(heading),
            })}
            alt={true}
          >
            {heading}
          </StyledHeading>
        )}
        <HtmlContent content={content} />
      </StyledInner>
    </StyledContainer>
  </StyledContent>
);

export default Content;
